import Index from './index.vue'
import List from './components/List.vue'

export default [
  {
    path: '/promotion',
    name: 'promotion',
    component: Index,
    title: 'Promotion',
    redirect: { name: 'promotion-list' },
    children: [
      {
        path: 'list',
        name: 'promotion-list',
        component: List,
      },
    ],
  },
]
